import React, { useEffect, useState, useRef } from 'react'
import Layouts from '../layout/layouts'
import ReactPaginate from 'react-paginate'
import uploadFileService from '../../../services/uploadFileService'
import baseURL from '../../utils/baseURL'
import Swal from 'sweetalert2'
import Loader from '../../common/Loader'

const swalStyles = `
  .swal-orange-btn {
      background-color: #F58634 !important;
      color: #fff !important;
      border: 1px solid #F58634 !important;
  }
  .swal-orange-btn:hover {
      background-color: #d77028 !important; /* Slightly darker orange for hover */
  }
`;

const UploadFileList = () => {
    const [files, setFiles] = useState([]);  
    const token = localStorage.getItem('token')
    const [currentPage, setCurrentPage] = useState(0); 
    const [searchQuery, setSearchQuery] = useState(''); 
    const [itemsPerPage, setItemsPerPage] = useState(10); 
    const [loader, setLoader] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [editId, setEditId] = useState(null);
    const [fileType, setFileType] = useState('Intro File');
    const [customFileName, setCustomFileName] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [existingFilePath, setExistingFilePath] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isSubmittingRef = useRef(false);

    useEffect(()=>{
        fetchFiles();
    },[])

    const fetchFiles = async()=>{  
        setLoader(false);
        try {
            const res = await uploadFileService.getFiles(token);
            setFiles(res.data?.result || []);
        } catch (error) {
            console.error("Error fetching files", error);
        }
        setLoader(true);
    }

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    const filteredData = files.filter(
        (item) => item.file_name.toLowerCase().includes(searchQuery.toLowerCase()) || item.type.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(0);
    };

    const handleItemsPerPageChange = (event) => {
        const newItemsPerPage = parseInt(event.target.value);
        setItemsPerPage(newItemsPerPage);
        const newIndex = Math.floor((currentPage * itemsPerPage) / newItemsPerPage);
        setCurrentPage(newIndex);
    }

    const offset = currentPage * itemsPerPage;
    const pageCount = Math.ceil(filteredData.length / itemsPerPage); 
    const paginatedData = filteredData.slice(offset, offset + itemsPerPage);

    const toggleStatus = async (id, currentStatus) => {
        try {
            await uploadFileService.toggleStatus(token, { id, isActive: !currentStatus });
            fetchFiles();
        } catch (error) {
            Swal.fire("Error", "Could not update status", "error");
        }
    };

    const handleFileChange = (e) => {
        if(e.target.files && e.target.files[0]) {
            setSelectedFile(e.target.files[0]);
        }
    };

    const handleEdit = (file) => {
        setEditId(file.id);
        setCustomFileName(file.file_name);
        setFileType(file.type);
        setExistingFilePath(file.file_path);
        setSelectedFile(null);
        setShowModal(true);
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn submit-button swal-orange-btn',
                cancelButton: 'btn custom-cancel-button me-3'
            },
            buttonsStyling: false
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await uploadFileService.deleteFile(token, id);
                    Swal.fire('Deleted!', 'The file has been deleted.', 'success');
                    fetchFiles();
                } catch (error) {
                    Swal.fire('Error', 'Could not delete file', 'error');
                }
            }
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if(isSubmittingRef.current) return;
        if(!customFileName.trim()) {
            Swal.fire("Warning", "Please enter a File Name", "warning");
            return;
        }
        if(!selectedFile && !editId) {
            Swal.fire("Warning", "Please select a file", "warning");
            return;
        }

        const formData = new FormData();
        formData.append("file_name", customFileName);
        formData.append("type", fileType);
        if (selectedFile) {
            formData.append("file", selectedFile);
        }

        try {
            isSubmittingRef.current = true;
            setIsSubmitting(true);
            if (editId) {
                await uploadFileService.editFile(token, editId, formData);
                Swal.fire("Success", "File updated successfully", "success");
            } else {
                await uploadFileService.uploadFile(token, formData);
                Swal.fire("Success", "File uploaded successfully", "success");
            }
            setShowModal(false);
            setCustomFileName('');
            setSelectedFile(null);
            setExistingFilePath('');
            setEditId(null);
            fetchFiles();
        } catch (error) {
            Swal.fire("Error", error.response?.data?.message || "Operation failed", "error");
        } finally {
            isSubmittingRef.current = false;
            setIsSubmitting(false);
        }
    };

    const handleKeyDown = (event) =>{
        if (event.key === 'Enter') {
            event.preventDefault(); 
        }
    }

    return (
        <Layouts>
            <style>{swalStyles}</style>
            <div className='admin-portfolio'>
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row header-set">
                    <div className="col-sm-6"> 
                        <h4 className="dash-title">Upload File</h4>
                    </div> 
                    <div className="col-sm-6">
                        <div className="float-sm-right">
                        <button className="btn add-techno-btn" onClick={() => { setEditId(null); setCustomFileName(''); setFileType('Intro File'); setSelectedFile(null); setExistingFilePath(''); setShowModal(true); }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <g clipPath="url(#clip0_3378_6837)">
                                <path d="M9 0C4.0371 0 0 4.0371 0 9C0 13.9629 4.0371 18 9 18C13.9629 18 18 13.9622 18 9C18 4.0378 13.9629 0 9 0ZM9 16.6057C4.80674 16.6057 1.39426 13.194 1.39426 9C1.39426 4.80604 4.80674 1.39426 9 1.39426C13.1933 1.39426 16.6057 4.80604 16.6057 9C16.6057 13.194 13.194 16.6057 9 16.6057Z" fill="white"/>
                                <path d="M12.4856 8.24013H9.69711V5.4516C9.69711 5.06678 9.38548 4.75446 8.99996 4.75446C8.61443 4.75446 8.30281 5.06678 8.30281 5.4516V8.24013H5.51429C5.12876 8.24013 4.81714 8.55245 4.81714 8.93728C4.81714 9.3221 5.12876 9.63442 5.51429 9.63442H8.30281V12.4229C8.30281 12.8078 8.61443 13.1201 8.99996 13.1201C9.38548 13.1201 9.69711 12.8078 9.69711 12.4229V9.63442H12.4856C12.8712 9.63442 13.1828 9.3221 13.1828 8.93728C13.1828 8.55245 12.8712 8.24013 12.4856 8.24013Z" fill="white"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_3378_6837">
                                <rect width="18" height="18" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                            <span className='ps-2'>Add File</span>
                        </button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            
            <div className='portfolio-body'>
                <div className="container-fluid">
                    <div className='row'>
                        <div className='col-12'>
                            <div className='card portfolio-card'>
                                <div className='card-body'>
                                <div className="table-responsive">
                                    <div className='table-search-box'>
                                        <form className="d-flex search-form" role="search">
                                            <label className='form-label'>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                <g clipPath="url(#clip0_3596_5383)">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M5.75 1.375C3.33375 1.375 1.375 3.33375 1.375 5.75C1.375 8.16625 3.33375 10.125 5.75 10.125C8.16625 10.125 10.125 8.16625 10.125 5.75C10.125 3.33375 8.16625 1.375 5.75 1.375ZM0.625 5.75C0.625 2.91954 2.91954 0.625 5.75 0.625C8.58046 0.625 10.875 2.91954 10.875 5.75C10.875 7.03026 10.4056 8.20087 9.62943 9.0991L11.2652 10.7348C11.4116 10.8813 11.4116 11.1187 11.2652 11.2652C11.1187 11.4116 10.8813 11.4116 10.7348 11.2652L9.0991 9.62943C8.20087 10.4056 7.03026 10.875 5.75 10.875C2.91954 10.875 0.625 8.58046 0.625 5.75Z" fill="#454545"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_3596_5383">
                                                    <rect width="12" height="12" fill="white"/>
                                                    </clipPath>
                                                </defs>
                                                </svg>
                                            </label>
                                            <input className="form-control search" type="search" placeholder="Search" value={searchQuery} onChange={handleSearchChange} onKeyDown={handleKeyDown} aria-label="Search"/> 
                                        </form>
                                    </div>
                                    
                                    <table className="table">
                                        <thead className="table-color">
                                        <tr>
                                            <th style={{width:"10%",textAlign:"center"}}>Sr no.</th>
                                            <th style={{width:"40%"}}>File Name</th>
                                            <th style={{width:"30%"}}>Type of File</th> 
                                            <th style={{width:"20%",textAlign:"center"}}>Action</th>
                                        </tr>
                                        </thead>
                                        { loader ?
                                        <tbody>  
                                        { 
                                            paginatedData && paginatedData.length > 0 ? ( paginatedData.map((list,index)=>
                                            <tr key={list.id}>
                                                <td className='td-style'>{index + offset + 1}</td>
                                                <td><a href={baseURL+"/"+list.file_path} target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>{list.file_name}</a></td>
                                                <td>{list.type}</td>  
                                                <td className='td-style' style={{textAlign:"center"}}>
                                                    <div className="d-flex justify-content-center align-items-center">
                                                        <div className="form-check form-switch mb-0" style={{ marginRight: '15px' }}>
                                                            <input 
                                                                className="form-check-input" 
                                                                type="checkbox" 
                                                                role="switch" 
                                                                checked={list.isActive} 
                                                                onChange={() => toggleStatus(list.id, list.isActive)}
                                                                style={{cursor: 'pointer'}}
                                                            />
                                                        </div>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16" style={{cursor: 'pointer', color: '#1F4168', marginRight: '15px'}} onClick={() => handleEdit(list)}>
                                                          <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                                          <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                                                        </svg>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16" style={{cursor: 'pointer', color: '#d33'}} onClick={() => handleDelete(list.id)}>
                                                          <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                                                          <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                                                        </svg>
                                                    </div>
                                                </td> 
                                            </tr>
                                            )):(
                                            <tr>
                                                <td colSpan={4} style={{textAlign:"center"}}>No records found</td>
                                            </tr>
                                            )
                                        } 
                                        </tbody>
                                        : <tbody><tr><td colSpan={4}><Loader/></td></tr></tbody> }
                                    </table>
                                    { 
                                        paginatedData.length > 0 &&
                                    <div className='table-footer'>
                                        <div className='table-show'>
                                            <span className='pe-3'>Show</span>
                                            <select className='numbershow' value={itemsPerPage} onChange={handleItemsPerPageChange}>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="30">30</option>
                                            </select>
                                        </div>
                                        <div className='table-pagination'>
                                            <ReactPaginate
                                                breakLabel="..."
                                                nextLabel="Next >"
                                                onPageChange={handlePageChange}
                                                pageRangeDisplayed={3}
                                                pageCount={pageCount}
                                                previousLabel="< Prev"
                                                renderOnZeroPageCount={null}
                                                containerClassName="pagination"
                                                pageClassName="page-item"
                                                pageLinkClassName="page-link"
                                                previousClassName="page-item"
                                                previousLinkClassName="page-link"
                                                nextClassName="page-item"
                                                nextLinkClassName="page-link"
                                                activeClassName="active"
                                            />
                                        </div>
                                    </div>
                                    }
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>

            {showModal && (
                <div style={modalOverlayStyle} onClick={(e) => { if (e.target === e.currentTarget) setShowModal(false) }}>
                    <div style={modalContentStyle}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 style={{ margin: 0, color: '#1f4168', fontWeight: 600 }}>{editId ? 'Edit File' : 'Add New File'}</h4>
                            <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                        </div>
                        <hr style={{ borderColor: '#d6d6d6', marginBottom: '25px' }} />
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className={editId && existingFilePath ? "col-md-6" : "col-md-12"}>
                                    <div className="form-group mb-4">
                                        <label style={{ fontWeight: 500, marginBottom: '8px', color: '#454545' }}>File Name</label>
                                        <input type="text" className="form-control" style={{ padding: '10px', borderRadius: '6px' }} placeholder="Enter a display name for the file" value={customFileName} onChange={(e) => setCustomFileName(e.target.value)} />
                                    </div>
                                    <div className="form-group mb-4">
                                        <label style={{ fontWeight: 500, marginBottom: '8px', color: '#454545' }}>Type of File</label>
                                        <select className="form-control" style={{ padding: '10px', borderRadius: '6px' }} value={fileType} onChange={(e) => setFileType(e.target.value)}>
                                            <option value="Intro File">Intro File</option>
                                            <option value="Thank You Slide">Thank You Slide</option>
                                        </select>
                                    </div>
                                    <div className="form-group mb-4">
                                        <label style={{ fontWeight: 500, marginBottom: '8px', color: '#454545' }}>Select File (PDF, JPEG, PNG)</label>
                                        <input type="file" className="form-control" style={{ padding: '10px', borderRadius: '6px' }} accept=".pdf, .jpg, .jpeg, .png" onChange={handleFileChange} />
                                    </div>
                                </div>
                                {editId && existingFilePath && (
                                    <div className="col-md-6 d-flex flex-column">
                                        <label style={{ fontSize: '13px', fontWeight: 600, color: '#666', display: 'block', marginBottom: '8px' }}>Currently Uploaded File:</label>
                                        <div className="p-2 border rounded d-flex align-items-center justify-content-center flex-grow-1" style={{ backgroundColor: '#f9f9f9', minHeight: '200px' }}>
                                            {existingFilePath.match(/\.(jpeg|jpg|gif|png)$/i) ? (
                                                <img src={`${baseURL}/${existingFilePath}`} alt="Preview" style={{ width: '100%', maxHeight: '300px', objectFit: 'contain', borderRadius: '4px' }} />
                                            ) : (
                                                <iframe src={`${baseURL}/${existingFilePath}`} title="PDF Preview" style={{ width: '100%', height: '300px', border: 'none', borderRadius: '4px' }} />
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="d-flex justify-content-end mt-5">
                                <button type="button" className="btn custom-cancel-button me-3" onClick={() => setShowModal(false)} disabled={isSubmitting}>Cancel</button>
                                <button type="submit" className="btn submit-button" disabled={isSubmitting} style={{backgroundColor: '#F58634', color: '#fff', border: '1px solid #F58634'}}>
                                    {isSubmitting ? 'Submitting...' : 'Submit'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </Layouts>
    )
}

const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 100000,
    backdropFilter: 'blur(3px)',
    paddingTop: '60px',
    paddingBottom: '20px'
};

const modalContentStyle = {
    backgroundColor: '#fff',
    padding: '40px 50px',
    borderRadius: '16px',
    width: '900px',
    maxWidth: '95%',
    maxHeight: 'calc(100vh - 100px)',
    overflowY: 'auto',
    boxShadow: '0 15px 35px rgba(0,0,0,0.2)',
    animation: 'fadeIn 0.3s ease-out'
};

export default UploadFileList;
